$(async function() {
  const collectionId = $("#main-collection-brand").data("collection-id");
  const shop = await SixtyPercentApiWebClient.fetchCollectionShop(collectionId);

  setRelatedArticles(shop);
  setSuperiorShopbadge(shop);
  setFavoriteButton(shop);
  setShopOfYear(shop);
});

function searchByShopTag(sectionId, vendors) {
  let queryString = vendors.map((vendor) => `tag:brand_${
    vendor.id
  }`).join(" OR ");

  fetch("".concat(window.routes.searchUrl, "?section_id=").concat(sectionId, "&type=article&q=").concat(queryString), {
    credentials: "same-origin",
    method: "GET"
  }).then(function(response) {
    response.text().then(function(content) {
      let tempElement = document.createElement("div");
      tempElement.innerHTML = content;

      $(`#shopify-section-${sectionId}`).html(tempElement.innerHTML);

      let carousel = $(`#shopify-section-${sectionId}`).find("div[data-slick-target='true']");
      if (carousel.length > 0) {
        carousel.slick(JSON.parse(carousel.data("slick")));
      }
    });
  });
}

function setRelatedArticles(shop) {
  $(".RelatedArticles").each(function() {
    const sectionId = $(this).data("section-id");
    if (shop.vendors.length > 0) {
      searchByShopTag(sectionId, shop.vendors);
    }
  });
}

function setSuperiorShopbadge(shop) {
  if (shop.superiorShop) {
    $(".ShopCollectionHeader__BadgesContainer").append(`
      <div id="SuperiorShopLabel"></div>
    `);
  }
}

function setShopOfYear(shop) {
  if (shop.superiorShop) {
    $(".ShopCollectionHeader_WithImageContent").addClass("ShopCollectionHeader_WithImageContent_LogoContainer");
    $(".ShopCollectionHeader__Container").html(`
      <div class="ShopCollectionHeader__BadgesContainer" style="flex-direction: column-reverse;">
        <span class="ShopCollectionHeader__OfficialBadge">
          <span class="ShopCollectionHeader__OfficialBadgeText">
            公式ショップ
          </span>
        </span>
        <div id="SuperiorShopLabel"></div>
      </div>
  `);
  }
}

function setFavoriteButton(shop) {
  $("#shop-favorited-count").text(shop.favoritedCount);
  if (shop.favoritedByCurrentCustomer) {
    $("#shop-favorite-button").addClass("IsFavorited");
    $("#shop-favorite-button .CollectionFavoriteButton__Text").text("お気に入りに追加済み");
  }
  $(".CollectionFavoriteButton").click(function() {
    if (shop.favoritedByCurrentCustomer == null) {
      $.toast({text: "ショップをお気に入りするにはログインが必要です", showHideTransition: "slide", position: "top-right", hideAfter: 5000});
    } else if (shop.favoritedByCurrentCustomer) {
      $("#shop-favorite-button").removeClass("IsFavorited");
      $("#shop-favorite-button .CollectionFavoriteButton__Text").text("お気に入りに追加する");
      shop.favoritedByCurrentCustomer = false;
      var currentCount = Number($("#shop-favorited-count").text());
      $("#shop-favorited-count").text(currentCount - 1);
      SixtyPercentApiWebClient.customerApp.removeFavoriteShop(shop.id);
    } else {
      $("#shop-favorite-button").addClass("IsFavorited");
      $("#shop-favorite-button .CollectionFavoriteButton__Text").text("お気に入りに追加済み");
      shop.favoritedByCurrentCustomer = true;
      var currentCount = Number($("#shop-favorited-count").text());
      $("#shop-favorited-count").text(currentCount + 1);
      SixtyPercentApiWebClient.customerApp.addFavoriteShop(shop.id);
    }
  });
}
